import { render, staticRenderFns } from "./FlexibleFeesInterface.vue?vue&type=template&id=765f40d8&scoped=true&"
import script from "./FlexibleFeesInterface.vue?vue&type=script&lang=js&"
export * from "./FlexibleFeesInterface.vue?vue&type=script&lang=js&"
import style0 from "./FlexibleFeesInterface.vue?vue&type=style&index=0&id=765f40d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765f40d8",
  null
  
)

export default component.exports